import i18n from '@/plugins/i18n';

/**
 * Vrací lokalizovanou hodnotu z objektu s překlady.
 * Priorita: aktuální locale → angličtina → první neprázdná hodnota → fallback
 *
 * @param translations - Objekt s překlady (např. { cs: "Název", en: "Name" }) nebo string
 * @param fallback - Fallback hodnota, pokud není žádný překlad dostupný (default: '')
 * @returns Lokalizovaná hodnota nebo fallback
 */
export function getLocalizedValue(
    translations: Record<string, string | null> | string | null | undefined,
    fallback: string = '',
): string {
    if (!translations) {
        return fallback;
    }

    if (typeof translations === 'string') {
        return translations;
    }

    const locale = i18n.global.locale.value || 'en';
    const value = translations[locale] || translations.en;

    if (value) {
        return value;
    }

    for (const val of Object.values(translations)) {
        if (val) {
            return val;
        }
    }

    return fallback;
}
